import { useState } from 'react';
import { useT } from '@hana/i18n';
import './screens.i18n';
import { IconCheck, IconX } from '@tabler/icons-react';
import s from './dock.module.css';

// Bảng phải của Mint-HR-1920 (Duyệt · Việc). Dữ liệu mẫu của board; không tiền / lương (offer chỉ hiện bậc và khung).

type DockTab = 'appr' | 'task';
const APPR: ReadonlyArray<{ k: string; sub: string; seat: string; when: string; ok: string }> = [
  { k: 'Đơn nghỉ PhuongHT · 3 ngày', sub: 'Phép năm · 03–05/Nov · bàn giao 14 việc → TranTPB', seat: '[SALE-MGR] DAVID · bước 1/2', when: '08:12', ok: 'Duyệt' },
  { k: 'Phiếu OT THANH · 2,5 h', sub: 'Xử lý xe hỏng 23:40 · log notify_chain', seat: '[TRD-MGR] PHONGNT (kiêm) → BOD', when: '07:05', ok: 'Duyệt' },
  { k: 'Offer · Trần Quốc Bảo', sub: 'SALE-SE L03 · trong khung', seat: '[BOD-DDIR] DAVID · tự duyệt có cờ', when: 'Hôm qua', ok: 'Duyệt' },
  { k: 'Đề nghị tuyển HRD-IT', sub: 'Ngoài định biên quý · vượt khung', seat: '[BOD-DIR] PHILIP', when: 'Hôm qua', ok: 'Chuyển BOD' },
  { k: 'Đơn nghỉ đột xuất MAITTN', sub: 'Vắng hôm nay · đã chuyển 9 việc → ThuyNTT', seat: '[SALE-MGR] DAVID · bổ sung trong 2 ngày', when: '07:31', ok: 'Ghi nhận' },
];
const TASKS: ReadonlyArray<{ k: string; due: string; code: string; warn?: true }> = [
  { k: 'Hết thử việc Võ Thị Lan — TBP đánh giá', due: 'Còn 5 ngày làm việc', code: 'PRB', warn: true },
  { k: 'Chốt công tháng 10', due: '02/Nov/2026', code: 'TMK' },
  { k: 'Nhập môn: cấp tài khoản Entra + mail', due: 'Hôm nay 16:00', code: 'ONB', warn: true },
  { k: 'Chứng chỉ ATVSLĐ của PHONGNT sắp hết hạn', due: '30 ngày', code: 'CRT' },
  { k: 'Đơn nghỉ của MAITTN cần bổ sung', due: 'Hạn 24/Oct/2026', code: 'ABS', warn: true },
];

export function HrDock({ initial = 'appr', onClose, onWrite }: { initial?: DockTab; onClose: () => void; onWrite: (msg: string) => void }) {
  const t = useT();
  const [tab, setTab] = useState<DockTab>(initial);
  const [apprDone, setApprDone] = useState<ReadonlySet<number>>(new Set());
  const [tkDone, setTkDone] = useState<ReadonlySet<number>>(new Set());
  const toggle = (set: ReadonlySet<number>, i: number) => {
    const n = new Set(set);
    if (n.has(i)) n.delete(i);
    else n.add(i);
    return n;
  };
  const tabs = [
    { key: 'appr' as const, label: 'Duyệt', n: APPR.length - apprDone.size },
    { key: 'task' as const, label: 'Việc', n: TASKS.length - tkDone.size },
  ];
  return (
    <div className={s.dock}>
      <div className={s.head}>
        <div role="tablist" aria-label="Bảng bên phải" className={s.tabs}>
          {tabs.map((t) => (
            <button key={t.key} type="button" role="tab" aria-selected={tab === t.key} className={`${s.tab} ${tab === t.key ? s.on : ''}`} onClick={() => setTab(t.key)}>
              {t.label} <span>{t.n}</span>
            </button>
          ))}
        </div>
        <button type="button" className={s.close} aria-label="Đóng bảng" onClick={onClose}>
          ×
        </button>
      </div>
      {tab === 'appr' &&
        APPR.map((a, i) => (
          <div key={a.k} className={s.card} style={{ opacity: apprDone.has(i) ? 0.45 : 1 }}>
            <div className={s.row}>
              <b>{a.k}</b>
              <span className={s.when}>{a.when}</span>
            </div>
            <div className={s.sub}>{a.sub}</div>
            <div className={s.seat}>{a.seat}</div>
            <div className={s.acts}>
              <button type="button" className={s.ok} onClick={() => { setApprDone(toggle(apprDone, i)); onWrite(`Đã duyệt: ${a.k}`); }}>
                <IconCheck size={16} stroke={1.8} aria-hidden="true" />
                {a.ok}
              </button>
              <button type="button" className={s.no} onClick={() => { setApprDone(toggle(apprDone, i)); onWrite(`Đã từ chối: ${a.k}`); }}>
                <IconX size={16} stroke={1.8} aria-hidden="true" />
                {t('hr.s.reject')}
              </button>
            </div>
          </div>
        ))}
      {tab === 'task' &&
        TASKS.map((t, i) => (
          <div key={t.code} className={s.task} style={{ opacity: tkDone.has(i) ? 0.5 : 1 }}>
            <input type="checkbox" aria-label={`Xong: ${t.k}`} checked={tkDone.has(i)} onChange={() => setTkDone(toggle(tkDone, i))} />
            <div>
              <div className={s.tk} style={{ textDecoration: tkDone.has(i) ? 'line-through' : 'none' }}>{t.k}</div>
              <div className={`${s.due} ${t.warn ? s.warnT : ''}`}>{t.due} · {t.code}</div>
            </div>
          </div>
        ))}
    </div>
  );
}
